import GenericCable from "./GenericCable";

export default class CatalogueImport extends GenericCable {
  async open() {
    super.open("CatalogueImportChannel");
  }
}
